
import { computed, defineComponent, PropType } from 'vue'
import {
  documentStatusLabels,
  documentStatusStyles,
  orderStatusLabels,
  orderStatusStyles,
  paymentStatusLabels,
  paymentStatusStyles,
  TagStyle,
} from '@/core/services/payment/labels'

type Kind = 'order' | 'payment' | 'document'

interface Dictionary {
  labels: Record<string, string>
  styles: Record<string, TagStyle>
}

/** Цветной статус заказа, платежа или документа (палитра в labels.ts). */
export default defineComponent({
  name: 'PaymentStatusTag',
  props: {
    kind: { type: String as PropType<Kind>, required: true },
    status: { type: String, required: true },
  },
  setup(props) {
    // Без кортежей в типах: старый парсер ESLint проекта (@typescript-eslint 2.x) на них падает.
    const dictionaries: Record<Kind, Dictionary> = {
      order: { labels: orderStatusLabels, styles: orderStatusStyles },
      payment: { labels: paymentStatusLabels, styles: paymentStatusStyles },
      document: { labels: documentStatusLabels, styles: documentStatusStyles },
    }
    const text = computed(() => dictionaries[props.kind].labels[props.status] || props.status)
    const style = computed(
      () => dictionaries[props.kind].styles[props.status] || { type: 'info', effect: 'light' }
    )
    return { text, style }
  },
})
